import './App.css';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import AddKategori from './Components/AddKategori/AddKategori';
import AddKuisioner from './Components/AddKuisioner/AddKuisioner';
import AddInformation from './Components/AddInformation/AddInformation';
import Dashboard from './Components/Dashboard/Dashboard';
import Information from './Components/Information/Information';
import Question from './Components/Questions/Question';
import React, { useState, useEffect } from 'react';
import Signup from './Components/Signup/Signup';
import Summary from './Components/Summary/Summary';
import Interpretation from './Components/Interpretation/Interpretation';
import TotalScore from './Components/TotalScore/TotalScore';
import WhatsAppButton from './Components/WhatsAppButton/WhatsAppButton';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const loggedInStatus = localStorage.getItem('isLoggedIn');
    if (loggedInStatus === 'true') {
      setIsLoggedIn(true);
    }
  }, []);

  const handleLogin = () => {
    setIsLoggedIn(true);
    localStorage.setItem('isLoggedIn', 'true');
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
    localStorage.removeItem('isLoggedIn');
  };

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  return (
    <Router>
      <div className="App">
        <h2>All you ready?</h2>
        <Routes>
          <Route path="/" element={<Information />} />
          <Route path="/signup" element={<Signup onLogin={handleLogin} />} />
          
          {isLoggedIn ? (
  <>
    <Route path="/Dashboard/*" element={<Dashboard isOpen={isOpen} toggleSidebar={toggleSidebar} handleLogout={handleLogout} />} />
    <Route path="/Question/:kategori" element={<Question isOpen={isOpen} toggleSidebar={toggleSidebar} handleLogout={handleLogout} />} />
    <Route path="/Summary" element={<Summary isOpen={isOpen} toggleSidebar={toggleSidebar} handleLogout={handleLogout} />} />
    <Route path="/AddKategori" element={<AddKategori isOpen={isOpen} toggleSidebar={toggleSidebar} handleLogout={handleLogout} />} />
    <Route path="/AddKuisioner" element={<AddKuisioner isOpen={isOpen} toggleSidebar={toggleSidebar} handleLogout={handleLogout} />} />
    <Route path="/AddInformation" element={<AddInformation isOpen={isOpen} toggleSidebar={toggleSidebar} handleLogout={handleLogout} />} />
    <Route path="/Interpretation" element={<Interpretation />} />
    <Route path="/TotalScore" element={<TotalScore />} />
  </>
) : (
  <Route path="*" element={<Navigate to="/signup" />} /> // Pastikan Navigate digunakan dalam Route
)}

        </Routes>
        <WhatsAppButton />
      </div>
    </Router>
  );
}

export default App;
